// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperNewsStory-cls1___fbad71abbcee03098a2{/*!*/}.PaperNewsStory-cls2___c389a48d1423a5ee9f4{}.PaperNewsStory-cls2___c389a48d1423a5ee9f4.PaperNewsStory-variant-dense__b1702cd86298a754b47f{font-family:\"DM Sans\";font-family:var(--type-font-family-sans-serif, \"DM Sans\");font-weight:400;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperNewsStory-cls1___fbad71abbcee03098a2",
	"cls2": "PaperNewsStory-cls2___c389a48d1423a5ee9f4 PaperNewsStory-cls1___fbad71abbcee03098a2",
	"variant-dense": "PaperNewsStory-variant-dense__b1702cd86298a754b47f"
};
export default ___CSS_LOADER_EXPORT___;
